import {CREACION_USUARIO_TYPES} from '../constants/creacionUsuario.types'
import {creacionUsuarioInitialState} from '../initital-state/creacionUsuario.state'
import {CreacionUsuarioAction, CreacionUsuarioState} from '../interfaces/creacionUsuario.interface'

const creacionUsuarioReducer = (
  state: CreacionUsuarioState = creacionUsuarioInitialState,
  action: CreacionUsuarioAction
): CreacionUsuarioState => {
  switch (action.type) {
    case CREACION_USUARIO_TYPES.FORM_HANDLE_CHANGE:
      return {...state, formUser: {...state.formUser, ...action.payload}}
    case CREACION_USUARIO_TYPES.FORM_VERIFY_CODE_HANDLE_CHANGE:
      return {...state, codeVerify: {...state.codeVerify, ...action.payload}}
    case CREACION_USUARIO_TYPES.FORM_ADD_ERROR:
      return {...state, formError: {...state.formError, ...action.payload}}
    case CREACION_USUARIO_TYPES.FORM_ADD_ERROR_VERIFY_CODE:
      return {...state, codeVerify: {...state.codeVerify, ...action.payload}}
    case CREACION_USUARIO_TYPES.FORM_CHANGE_PAGE:
      return {...state, paginaActual: state.paginaActual + action.payload}
    case CREACION_USUARIO_TYPES.FORM_CLEAR:
      return creacionUsuarioInitialState
    default:
      return state
  }
}

export default creacionUsuarioReducer
